import React from 'react';

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth';

const InvoiceFooter = () => (
  <div className="invoice-payment">
    <div>
      <div>Payment Options:</div>
      <p>1) Cheque, $45 service charge levied on all returned cheques.</p>
      <p>
        2){' '}
        {CLIENT === 'woodworth'
          ? 'Email transfer to sales@de-valor.ca.'
          : 'Zelle transfer to sales@dw-cabinetry.com'}
      </p>
      <p>
        3) Credit Card payment is subject to{' '}
        {CLIENT === 'woodworth' ? '2.0%' : '3.0%'} of surcharge.
      </p>
      <p>4) Debit Card no Charge.</p>
    </div>
  </div>
);

export default InvoiceFooter;
